export function getContainingRectangle(rectangle) {
  /**
   * Calculations:
   *      xPrime1   x,y   xPrime2
   *            \/   |     \/
   *           +--------------+
   *           |    /\ rot    |
   * yPrime1 ->|   /  \       |
   *           |  /h   \      |
   *           | /      \     |
   *   x1,y1 ->|<       w\    |
   *           | \        \   |
   *           |  \        \  |
   *           |   \        \ |
   * yPrime2 ->|    \        >|<- x2,y2
   *           |     \      / |
   *           |      \    /  |
   *           |       \  /   |
   *           |        \/    |
   *           +--------------+
   *                     |
   *                   x3,y3
   */
  var h = rectangle.height;
  var w = rectangle.width;
  var xSet = rectangle.x;
  var ySet = rectangle.y;
  var rot = (rectangle.rotation * Math.PI) / 180; // Rotation in radians

  var xPrime1 = h * Math.sin(rot);
  var xPrime2 = w * Math.cos(rot);
  var yPrime1 = h * Math.cos(rot);
  var yPrime2 = w * Math.sin(rot);

  var x1 = xSet - xPrime1;
  var x2 = xSet + xPrime2;
  var x3 = x1 + xPrime2;

  var y1 = ySet + yPrime1;
  var y2 = ySet + yPrime2;
  var y3 = y1 + yPrime2;

  var newX1 = xSet;
  var newY1 = ySet;
  var newX2 = xSet;
  var newY2 = ySet;

  if (x1 < newX1) newX1 = x1;
  if (x2 < newX1) newX1 = x2;
  if (x3 < newX1) newX1 = x3;
  if (y1 < newY1) newY1 = y1;
  if (y2 < newY1) newY1 = y2;
  if (y3 < newY1) newY1 = y3;

  if (x1 > newX2) newX2 = x1;
  if (x2 > newX2) newX2 = x2;
  if (x3 > newX2) newX2 = x3;
  if (y1 > newY2) newY2 = y1;
  if (y2 > newY2) newY2 = y2;
  if (y3 > newY2) newY2 = y3;

  return { x: newX1, y: newY1, width: newX2 - newX1, height: newY2 - newY1 };
}

export function contains(outerRect, innerRect) {
  return (
    outerRect.x < innerRect.x &&
    outerRect.y < innerRect.y &&
    outerRect.x + outerRect.width > innerRect.x + innerRect.width &&
    outerRect.y + outerRect.height > innerRect.y + innerRect.height
  );
}

export function intersects(outerRect, innerRect) {
  return (
    outerRect.x - innerRect.width < innerRect.x &&
    outerRect.y - innerRect.height < innerRect.y &&
    outerRect.x + outerRect.width + innerRect.width >
      innerRect.x + innerRect.width &&
    outerRect.y + outerRect.height + innerRect.height >
      innerRect.y + innerRect.height
  );
}
